// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suggest-skill-option[data-v-62bdb71c]{grid-gap:.7rem;gap:.7rem;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
